module.exports = __webpack_public_path__ + "static/media/instant-cash.772d7ce3.jpg";